import React from "react"
import { Link as RouterLink } from "react-router-dom"
import { Box, Button, Container, Typography } from "@mui/material"

export default function NotFound() {
  return (
    <Container>
      <Typography variant="h3" sx={{ textAlign: "center", mt: "3em" }}>
        PAGE NOT FOUND
      </Typography>
      <Typography variant="body1" sx={{ textAlign: "center", py: 2 }}>
        ご指定のページが見つかりませんでした。
        <br />
        ページが移動または削除されたか、URLの入力間違いの可能性があります。
      </Typography>
      <Button component={RouterLink} to="/" sx={{ display: "flex" }}>
        ホームページに戻る
      </Button>
    </Container>
  )
}
